'use strict';

(function ($) {
    if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
    }

    function stopAutoplay($slider) {
        if ($slider[0].slick && $slider.slick('slickGetOption', 'autoplay')) {
            $slider.slick('slickPause');
        }
    }

    function stopAutoplayOnceSlickHasStartedPlaying($slider) {
        setTimeout(function () {
            stopAutoplay($slider);
        }, 0);
    }

    $(document).on('init', '.slick-slider', function () {
        stopAutoplayOnceSlickHasStartedPlaying($(this));
    });

    $(function () {
        $('.slick-initialized').each(function () {
            stopAutoplay($(this));
        });
    });
})(jQuery);
